import React from 'react';
import {
    Box,
    Center,
    Stack,
    Text,
    Link,
    Heading,
    Wrap,
} from "@chakra-ui/layout";
import {
    useColorModeValue as mode,
    Button,
} from "@chakra-ui/react";
import { useRouter } from "next/dist/client/router";
import * as analytics from "../../utils/analytics";
import { textStyle, variant } from 'theme/names';



const SubscribePopup = ({}) => {
    const router = useRouter();


    return (
      <Center>
        <Stack
          borderRadius={8}
          boxShadow="0px 0px 10px #ddd"
          borderColor={mode("gray.200", "gray.500")}
          background={mode("white", "gray.800")}
          p={6}
          css={{
            position: "absolute",
            // bottom: "20px",
            top: "calc(2000px - 60vw)",
            zIndex: 100,
          }}
        >
          <Heading
            maxW={400}
            textAlign="center"
            fontSize="lg"
            mb={5}
            lineHeight={8}
          >
            Unlock all search results and thousands of other viral posts
          </Heading>
          <Center mb={10}>
            <Box maxW={400} mb={5}>
              {[
                "✅ \xa0\xa0 Unlimited results",
                "✅ \xa0\xa0 Daily post inspiration",
                "✅ \xa0\xa0 Daily AI-generated posts",
                "✅ \xa0\xa0 Get industry news",
                "✅ \xa0\xa0 Save posts to list",
              ].map((e) => {
                return (
                  <Text textStyle={textStyle["body.medium.light"]} key={e} m={1}>
                    {e}
                  </Text>
                );
              })}
            </Box>
          </Center>
          <Center>
            <Button
              maxW={200}
              onClick={() => {
                
                router.push("/pricing");
              }}
              // leftIcon={<FiUnlock />}
              variant={variant.Button.primary}
            //   colorScheme="twitter"
            >
              Start Free Trial
            </Button>
          </Center>
        </Stack>
      </Center>
    );
}

export default SubscribePopup;